import Comps from '@owenscorning/react-library';
import React from 'react';
import { useSelector, useDispatch } from 'react-redux';

import CTAButton from '../../../CTAButton';
import BackButton from '../../shared/BackButton';
import AddressVerificationModal from '../helpers/address-verification-modal';
import { setFormData, incrementStep, verifyAddress } from '../redux/action';

const { AddressGroup } = Comps.Connect.FormElements;
const TextInput = Comps.Connect.FormElements.Text;
const { Spinner } = Comps.Connect;

const NewContractorClaim = () => {
  const { formData, isFetching } = useSelector(state => state);
  const dispatch = useDispatch();

  const validated =
    formData.newContractorInfo.company &&
    formData.newContractorInfo.firstName &&
    formData.newContractorInfo.lastName &&
    formData.newContractorInfo.phone &&
    formData.newContractorInfo.phone.length === 12 &&
    formData.newContractorInfo.street &&
    formData.newContractorInfo.city &&
    formData.newContractorInfo.state &&
    formData.newContractorInfo.zip;

  return (
    <div>
      <BackButton
        analytics={{
          'data-track': 'form-back',
          'data-track-form-name': 'Submit Claim',
          'data-track-form-step': 'step 1 - property claim by',
        }}
        onClick={() => dispatch(setFormData({ showNewContractorForm: false }))}
        backText="For this property, are you the..."
      />
      <p>Please submit your details, to continue your claim:</p>

      <div>
        <TextInput
          name="company"
          value={formData.newContractorInfo.company || ''}
          htmlAttributes={{
            placeholder: 'Company Name',
          }}
          onChange={value =>
            dispatch(
              setFormData({
                newContractorInfo: {
                  ...formData.newContractorInfo,
                  company: value,
                },
              })
            )
          }
        />
      </div>
      <div className="twoFields">
        <div className="inputWrap mr10">
          <TextInput
            name="firstName"
            value={formData.newContractorInfo.firstName || ''}
            htmlAttributes={{
              placeholder: 'First Name',
            }}
            onChange={value =>
              dispatch(
                setFormData({
                  newContractorInfo: {
                    ...formData.newContractorInfo,
                    firstName: value,
                  },
                })
              )
            }
          />
        </div>
        <div className="inputWrap ml10">
          <TextInput
            name="contractorEmail"
            value={formData.newContractorInfo.lastName || ''}
            htmlAttributes={{
              placeholder: 'Lastname',
            }}
            onChange={value =>
              dispatch(
                setFormData({
                  newContractorInfo: {
                    ...formData.newContractorInfo,
                    lastName: value,
                  },
                })
              )
            }
          />
        </div>
      </div>

      <AddressGroup
        value={formData.newContractorInfo}
        onChange={address =>
          dispatch(
            setFormData({
              newContractorInfo: {
                ...formData.newContractorInfo,
                ...address,
              },
            })
          )
        }
        suggestionEndpoint={`${MDMS_URL}/api/v1/smarty/suggestions`}
        showComplaints={false}
        country={formData.countrySelected}
      />

      <div>
        <TextInput
          name="phone"
          value={formData.newContractorInfo.phone || ''}
          htmlAttributes={{
            placeholder: 'Phone Number',
            pattern: '[0-9 -]*',
            maxLength: 12,
            isPhoneInput: 'true',
          }}
          onChange={value =>
            dispatch(
              setFormData({
                newContractorInfo: {
                  ...formData.newContractorInfo,
                  phone: value,
                },
              })
            )
          }
        />
      </div>

      <CTAButton
        onClick={() => dispatch(verifyAddress('newContractorInfo'))}
        data-track="form-advance"
        data-track-form-name="Submit Claim"
        data-track-form-step="step 1 - property claim by"
        element="button"
        text={
          isFetching ? (
            <>
              <Spinner /> Loading
            </>
          ) : (
            'Next'
          )
        }
        type="submit"
        disabled={!validated}
      />
      <AddressVerificationModal fieldKey="newContractorInfo" />
    </div>
  );
};

export default NewContractorClaim;
